export enum MODEL_TYPES {
  TEXT = 'text',
  VISION = 'vision',
}
